import { SubscriptionService } from '@/services'
import { DELIVERY_PATTERN } from '@/constants'

export default {
  data() {
    return {
      // paymentMethods: Object.entries(this.Constants.PAYMENT_METHOD).map(([key, val]) => ({
      //   value: val,
      //   label: this.$t(`common.paymentMethod.${this.$_.camelCase(key)}`),
      // })),
      numberOfPayments: Object.entries(this.Constants.NUMBER_OF_PAYMENT).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.numberOfPayment.${this.$_.camelCase(key)}`),
      })),
      deliveryPatterns: Object.entries(this.Constants.DELIVERY_PATTERN).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.deliveryPattern.${this.$_.camelCase(key)}`),
      })),
      deliveryDestinations: Object.entries(this.Constants.DELIVERY_DESTINATION).map(([key, val]) => ({
        value: val,
        label: this.$t(`common.deliveryDestination.${this.$_.camelCase(key)}`),
      })),
    }
  },

  methods: {
    /**
     * Calculator first delivery date
     * @param {*} desiredDeliveryDay
     * @returns
     */
    calcFirstDeliveryDate(desiredDeliveryDay, isHokkaido = false) {
      return desiredDeliveryDay
        ? desiredDeliveryDay
        : this.$date.getTime(
            this.$date.add(new Date(), {
              days: isHokkaido ? 5 : 5, // EC-2697
            })
          )
    },
    /**
     * Calcualtor second delivery date
     * @param {*} deliveryInterval
     * @returns
     */
    async calcSecondDeliveryDate({
      deliveryInterval,
      nextDeliveryDate,
      firstDeliveryDate,
      deliveryPattern = DELIVERY_PATTERN.MONTHLY_DATE_SPECIFICATION,
    }) {
      const { data } = await SubscriptionService.getDeliveryDateNext({
        delivery_date: this.Utils.date.getDateString(nextDeliveryDate),
        subscription_division_id: deliveryPattern,
        param1: deliveryInterval,
        param2: this.$date.getDate(new Date(firstDeliveryDate)),
        param3: 0,
      })
      return data.next_date
    },

    genDesiredDeliveryDays(isHokkaido = false) {
      return [
        {
          value: '',
          label: this.$t('common.unspecified'),
        },
        ...Array.from(Array(58).keys()).map((index) => {
          const date = this.$date.add(this.$date.startOfDay(new Date()), {
            days: index + isHokkaido ? 5 : 5, // EC-2697
          })

          return {
            value: date.getTime(),
            label: this.Utils.date.formatDateJP(date),
          }
        }),
      ]
    },

    subTotal(subscription) {
      return this.Utils.helper.subTotals(
        this.$store.state.cart.carts?.filter(
          (item) =>
            item.subscription === subscription &&
            item.visible &&
            [undefined, true].includes(item.is_product_sku_valid) &&
            item.is_out_stock === false
        )
      )
    },

    shippingFee(subscription) {
      return this.subTotal(subscription) >= this.$store.state.cart.freeAmount ? 0 : this.$store.state.cart.shippingFee
    },

    total(subscription) {
      return this.shippingFee(subscription) + this.subTotal(subscription)
    },
  },
}
